/**
 * Scroll to next element
 *
 * @param {string} scroll
 * @returns {void}
 */
const scrollToNext = (scroll) => {
    const $scroll = $(scroll);
    let $next = $scroll.parents('.section-heading').next();

    $scroll.on('click', () => {

        $('html, body').animate({
            scrollTop: $next.offset().top
        }, 800);
    });

    if($next.length > 0) {

        console.log($next.offset().top );
        console.log($next);
        $(window).on('scroll', function () {

            $next = $scroll.parents('.section-heading').next();

            if($(window).scrollTop() >= ($next.offset().top - 300)) {

                if(!$scroll.hasClass('hidden')) {
                    $scroll.addClass('hidden');
                }

            }
            else {

                if($scroll.hasClass('hidden')) {
                    $scroll.removeClass('hidden');
                }
            }
        })
    }

};

export default scrollToNext;
